export default __webpack_public_path__ + "static/media/file-icon.c17934d6.svg";